import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation } from "swiper/modules";

export default function App() {
  return (
    <>
      <Swiper
        slidesPerView={1}
        spaceBetween={10}
        navigation={true}
        modules={[Navigation]}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        }}
        className="mySwiper flash-slider"
      >
        <SwiperSlide className="why-choose-slider-token">
          <div className="technical-why-choose-card technical-swiper">
            <img
              src={require("../../image/new_token-development/technical.png")}
              alt="Crypto Token Development Company"
              className="technical-icon"
            />
            <img
              src={require("../../image/new_token-development/technical-before.png")}
              alt="Crpto Token Development Company"
              className="technical-before-icon"
            />
            <h4>Finance</h4>
            <p>Enabling secure and transparent financial transactions.</p>
          </div>
        </SwiperSlide>
        <SwiperSlide className="why-choose-slider-token">
          <div className="technical-why-choose-card various-swiper">
            <img
              src={require("../../image/new_token-development/various.png")}
              alt="Crypto Token Development Company"
              className="technical-icon"
            />
            <img
              src={require("../../image/new_token-development/various-token-before.png")}
              alt="Crpto Token Development Company"
              className="technical-before-icon"
            />
            <h4>Gaming</h4>
            <p>Creating in-game currencies and NFTs.</p>
          </div>
        </SwiperSlide>
        <SwiperSlide className="why-choose-slider-token">
          <div className="technical-why-choose-card Evaluation-swiper">
            <img
              src={require("../../image/new_token-development/evaluation.png")}
              alt="Crypto Token Development Company"
              className="technical-icon"
            />
            <img
              src={require("../../image/new_token-development/evaluation-quality-before.png")}
              alt="Crpto Token Development Company"
              className="technical-before-icon"
            />
            <h4>Real Estate</h4>
            <p>Tokenizing real estate assets for fractional ownership.</p>
          </div>
        </SwiperSlide>
        <SwiperSlide className="why-choose-slider-token">
          <div className="technical-why-choose-card Blockchain-swiper">
            <img
              src={require("../../image/new_token-development/blockchain-developer.png")}
              alt="Crypto Token Development Company"
              className="technical-icon"
            />
            <img
              src={require("../../image/new_token-development/blockchain-developer-before.png")}
              alt="Crpto Token Development Company"
              className="technical-before-icon"
            />
            <h4>Healthcare</h4>
            <p>Enhancing data security and interoperability.</p>
          </div>
        </SwiperSlide>
        <SwiperSlide className="why-choose-slider-token">
          <div className="technical-why-choose-card Enhanced-swiper">
            <img
              src={require("../../image/new_token-development/enhanced.png")}
              alt="Crypto Token Development Company"
              className="technical-icon"
            />
            <img
              src={require("../../image/new_token-development/enhanced-before.png")}
              alt="Crpto Token Development Company"
              className="technical-before-icon"
            />
            <h4>Entertainment</h4>
            <p>Developing tokens for content creators and their audiences.</p>
          </div>
        </SwiperSlide>
        <SwiperSlide className="why-choose-slider-token">
          <div className="technical-why-choose-card ico-swiper">
            <img
              src={require("../../image/new_token-development/ico-launch.png")}
              alt="Crypto Token Development Company"
              className="technical-icon"
            />
            <img
              src={require("../../image/new_token-development/ico-launch-before.png")}
              alt="Crpto Token Development Company"
              className="technical-before-icon"
            />
            <h4>Supply Chain</h4>
            <p>Improving transparency and traceability.</p>
          </div>
        </SwiperSlide>

        <SwiperSlide className="our-premium-crypto-none-slider"></SwiperSlide>
      </Swiper>
    </>
  );
}
